// removed by extract-text-webpack-plugin
module.exports = {"cornerMarker":"cornerMarker___13ONQ","textContent":"textContent___2JxZE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CornerMarker/index.modules.less
// module id = 698
// module chunks = 438